import * as React from "react";
import { Type } from "lucide-react";

import { SimpleSelect } from "@/components/ui";
import { SocialNetworkPosted, socialNetworkNames, SocialNetworksId, VideoProjectDetail } from "@/interfaces";

import { DetailSection } from "./DetailSection";

const SOCIAL_NETWORK_ORDER: SocialNetworksId[] = ["FB", "LI", "IG", "IG_STORY", "TW", "TT"];

interface Props {
  videoProject: VideoProjectDetail;
}

export const ProjectCaption: React.FC<Props> = ({ videoProject }) => {
  const networkCaptions = React.useMemo(() => {
    const socialNetworks = videoProject.post?.socialNetworks ?? [];
    return SOCIAL_NETWORK_ORDER.map(id => socialNetworks.find(sn => sn.socialNetworkId === id)).filter(
      (sn): sn is SocialNetworkPosted => !!sn?.caption
    );
  }, [videoProject.post?.socialNetworks]);

  const [selectedNetworkId, setSelectedNetworkId] = React.useState<string>();
  const activeNetworkId = selectedNetworkId ?? networkCaptions[0]?.socialNetworkId;

  const caption =
    networkCaptions.length > 0
      ? networkCaptions.find(sn => sn.socialNetworkId === activeNetworkId)?.caption
      : videoProject.messageToPost;

  const networkPicker = networkCaptions.length > 0 && (
    <SimpleSelect
      className="text-xs font-semibold text-slate-600"
      align="end"
      value={activeNetworkId}
      onValueChange={setSelectedNetworkId}
      items={networkCaptions.map(sn => ({
        value: sn.socialNetworkId,
        label: socialNetworkNames[sn.socialNetworkId],
      }))}
    />
  );

  return (
    <DetailSection icon={Type} iconClassName="text-slate-500" title="Caption" action={networkPicker}>
      <p data-elm-id="videoProjectDetailCaption" className="m-0 whitespace-pre-wrap break-words text-sm text-slate-700">
        {caption || <span className="text-slate-400">No caption yet.</span>}
      </p>
    </DetailSection>
  );
};
